module.exports={render:function (){with(this) {
  return _h('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside:touchstart",
      value: (onSwipeMove),
      expression: "onSwipeMove",
      arg: "touchstart"
    }],
    staticClass: "ion-item-sliding item-wrapper",
    class: [actived ? 'active-slide active-options-right' : ''],
    on: {
      "click": function($event) {
        onSwipeMove()
      },
      "touchstart": onStartDrag,
      "touchmove": onDrag,
      "touchend": endDrag
    }
  }, [_t("default")])
}},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0019bfdc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/item/src/item.sliding.vue
// module id = 150
// module chunks = 0